import React from 'react'

const CustomArrowIcon = (props = {}) => {
  const {
    className = '',
    width = '24',
    height = '24',
    fill = 'none',
    viewBox = '0 0 24 24',
    dataTestId = 'left-arrow-icon',
    ariaLabel = 'Left Icon',
    fillColor = '#252525', // Set default fill color to white
  } = props || {}
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      className={className}
      viewBox={viewBox}
      data-testid={dataTestId}
      aria-label={ariaLabel}>
      <g clip-path="url(#clip0_25819_38891)">
        <path
          d="M23.9917 11.9961C23.9916 15.1774 22.7275 18.228 20.478 20.4775C18.2284 22.7272 15.1771 23.9912 11.9956 23.9912C9.62319 23.9911 7.30413 23.2878 5.33154 21.9697C3.35886 20.6516 1.8215 18.7779 0.913573 16.5859C0.00572714 14.3941 -0.231885 11.9821 0.230957 9.65527C0.693847 7.32843 1.83659 5.19124 3.51416 3.51367C5.19177 1.83611 7.32888 0.693314 9.65576 0.230468C11.9827 -0.232367 14.3945 0.0052 16.5864 0.913086C18.7783 1.821 20.6521 3.3584 21.9702 5.33105C23.2883 7.30374 23.9917 9.62356 23.9917 11.9961ZM22.2866 11.9961C22.2844 9.26755 21.1994 6.65105 19.27 4.72168C17.3406 2.79231 14.7241 1.70734 11.9956 1.70508C9.96044 1.70515 7.97099 2.30877 6.27881 3.43945C4.58657 4.57018 3.26764 6.17731 2.48877 8.05762C1.70996 9.93784 1.50589 12.0069 1.90283 14.0029C2.2999 15.9991 3.28007 17.8333 4.71924 19.2725C6.1584 20.7116 7.99259 21.6918 9.98877 22.0889C11.9848 22.4858 14.0539 22.2817 15.9341 21.5029C17.8144 20.7241 19.4215 19.4051 20.5522 17.7129C21.6829 16.0207 22.2866 14.0313 22.2866 11.9961ZM16.9995 12C16.9995 12.5522 16.6073 12.9999 16.1235 13L5.87549 13C5.39169 12.9999 4.99951 12.5522 4.99951 12C4.99959 11.4478 5.39174 11.0001 5.87549 11L16.1235 11C16.6073 11.0001 16.9994 11.4478 16.9995 12Z"
          fill="#252525"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.6192 11.3813C18.9609 11.723 18.9609 12.277 18.6192 12.6187L12.4942 18.7437C12.1525 19.0854 11.5985 19.0854 11.2568 18.7437C10.9151 18.402 10.9151 17.848 11.2568 17.5063L16.7631 12L11.2568 6.49372C10.9151 6.15201 10.9151 5.59799 11.2568 5.25628C11.5985 4.91457 12.1525 4.91457 12.4942 5.25628L18.6192 11.3813Z"
          fill="#252525"
        />
      </g>
      <defs>
        <clipPath id="clip0_25819_38891">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

export default CustomArrowIcon
export { CustomArrowIcon }
